"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Anchor = _interopRequireDefault(require("../../general/Anchor"));

var _PropUtils = require("../../../util/PropUtils");

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var HeaderNav = function HeaderNav(props) {
  var _context;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "header-nav",
    "data-id": props["data-id"]
  }, (0, _map.default)(_context = props.options).call(_context, function (option, i) {
    var handleClick = function handleClick() {
      return props.onNavChange(option.id || option.label);
    };

    return props.renderNavItem({
      "data-id": option.label.replace(/\W/g, "") + "-label",
      className: (0, _classnames.default)("header-nav__item", {
        "header-nav__item--selected": option.id === props.currentNav || option.label === props.currentNav
      }),
      onClick: handleClick,
      item: option,
      option: option,
      key: option.label + "-" + i,
      children: /*#__PURE__*/_react.default.createElement("span", {
        className: "header-nav__item-label"
      }, option.label)
    }, _Anchor.default);
  }));
};

HeaderNav.propTypes = {
  currentNav: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  "data-id": _propTypes.default.string,
  options: _propTypes.default.array,
  onNavChange: _propTypes.default.func
};
HeaderNav.defaultProps = {
  currentNav: "",
  "data-id": "header-nav",
  onNavChange: _underscore.default.noop,
  renderNavItem: _PropUtils.defaultRender
};
var _default = HeaderNav;
exports.default = _default;
module.exports = exports["default"];